import type { ReactNode } from "react";
import { SectionHeader } from "./SectionHeader";

interface ContentSectionProps {
  icon: ReactNode;
  title: string;
  children: ReactNode;
  showDivider?: boolean;
  action?: ReactNode;
}

/**
 * Wraps a section with an icon header and optional bottom divider.
 * Extracted from ReportReviewPage and ConsultationWorkspacePage to
 * eliminate repeated section + SectionHeader + hr blocks.
 */
export function ContentSection({ icon, title, children, showDivider = true, action }: ContentSectionProps) {
  return (
    <>
      <section className="px-0">
        <div className="flex items-center justify-between">
          <SectionHeader icon={icon} title={title} />
          {action}
        </div>
        {children}
      </section>
      {showDivider && <hr className="border-stroke-primary" />}
    </>
  );
}
